import {LoginResData, ResPutData} from "../models/LoginStore";
import {RegisterDataType, RegisterResData, ResCode} from "../models/RegisterStore";
import {miniPersistStore} from "../models/MiniPersistStore";
import Fetcher from "@netless/fetch-middleware";
import { getCurrentLan } from "@netless/i18n-react-router";
if (!process.env.CONSOLE_LAMBDA_ORIGIN) {
    throw new Error("need set process.env.CONSOLE_LAMBDA_ORIGIN");
}
const fetcher = new Fetcher(10000, process.env.CONSOLE_LAMBDA_ORIGIN);
export class UserInfOperator {
    public async getUserData(email: string, password: string): Promise<any> {
        const json = await fetcher.post<any>({
            path: "login",
            body: {
                email: email,
                password: password,
            },
        });
        return json as any;
    }

    public async ssoUserData(sso: {email?: string, password?: string, url?: any, token?: string}): Promise<LoginResData> {
        const sdkToken = sso.token;
        if (sdkToken) {
            const json = await fetcher.post<any>({
                query: {
                    return_to: sso.url,
                },
                headers: {
                    token: sdkToken,
                },
                path: "login-sso",
            });
            return json as LoginResData;
        } else {
            const json = await fetcher.post<any>({
                query: {
                    return_to: sso.url,
                },
                path: "login-sso",
                body: {
                    email: sso.email,
                    password: sso.password,
                },
            });
            return json as LoginResData;
        }
    }

    public async sendEmail(): Promise<ResPutData> {
        const isEnglish: boolean = getCurrentLan() === "en";
        const json = await fetcher.post<any>({
            path: "register-emails/sending",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                region: isEnglish && "en",
            },
        });
        return json as ResPutData;
    }
    public async getTokenByCodeAndEmail(code: string, email: string): Promise<any> {
        const json = await fetcher.post<any>({
            path: "register-emails/checking",
            body: {
                code: code,
                email: email,
            },
        });
        return json as any;
    }

    public async upDateUserInf(name: string, token: string): Promise<ResPutData> {
        const json = await fetcher.put<any>({
            path: "admins",
            body: {
                name: name,
            },
            query: {
                token: token,
            },
        });
        return json as ResPutData;
    }

    public async upDateCompanyInf(name: string, address: string, token: string): Promise<ResPutData> {
        const json = await fetcher.put<any>({
            path: "teams",
            body: {
                name: name,
                address: address,
            },
            query: {
                token: token,
            },
        });
        return json as ResPutData;
    }

    public async initiativeResetPassword(oldPassword: string, password: string): Promise<any> {
        const json = await fetcher.put<any>({
            path: "users/passwords",
            body: {
                password: oldPassword,
                newPassword: password,
            },
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async resetPassword(email: string, password: string, code: string): Promise<any> {
        const json = await fetcher.put<any>({
            path: "users/passwords/resetting",
            body: {
                email: email,
                code: code,
                password: password,
            },
        });
        return json as any;
    }

    public async loginResetPassword(email: string): Promise<ResPutData> {
        const json = await fetcher.post<any>({
            path: "reset-password-emails/sending",
            body: {
                email: email,
            },
        });
        return json as ResPutData;
    }

    public async registerUserData(registerData: RegisterDataType): Promise<RegisterResData> {
        const json = await fetcher.post<any>({
            path: "admins",
            body: {
                email: registerData.email,
                phone: registerData.phone,
                code: registerData.code,
                password: registerData.password,
                passwordAgain: registerData.passwordAgain,
                currency: registerData.currency,
            },
        });
        return json as RegisterResData;
    }

    public async teamData(): Promise<any> {
        const json = await fetcher.get<any>({
            path: "teams",
            query: {
                token: miniPersistStore.token,
            },
        });
        return json as any;
    }

    public async sendCode(region: string, phone: string): Promise<any> {
        const isCn = (region === "" || region === "86");
        const json = await fetcher.post<any>({
            path: "phone-codes/sending",
            body: {
                phone: isCn ? phone : `${region}${phone}`,
                region: isCn ? "cn" : "en",
            },
        });
        return json as any;
    }

}



// WEBPACK FOOTER //
// ./src/apiMiddleware/UserInfOperator.ts